import React from "react";
import styles from "./InfoPageHeroBlock.module.scss";
import classNames from "classnames";
import { ReactComponentPropsBase } from "../../../base-props/ReactComponentPropsBase";
import BlockContainer from "components/layout/BlockContainer/BlockContainer";
import MultiMediaBlock from "../MultiMediaBlock/MultiMediaBlock";
import IconMS from "src/components/utils/IconMS/IconMS";
import { ImageProps } from "../../../components/base/Image/Image";
import { VideoProps } from "components/shared/Video/Video";
import useHeroBackground from "src/utils/use-hero-background/useHeroBackground";
import { useTheme } from "src/utils/useTheme";

export interface InfoPageHeroBlockProps extends ReactComponentPropsBase {
  byline?: string;
  heading: string;
  image?: ImageProps;
  mediaText?: string;
  publishDate?: string;
  showLessText?: string;
  showMoreText?: string;
  subHeading?: string;
  mediaSize?: "small" | "medium" | "large";
  videoLink?: VideoProps;
}

const InfoPageHeroBlock: React.FC<InfoPageHeroBlockProps> = ({
  byline,
  heading,
  image,
  mediaText,
  publishDate,
  showLessText,
  showMoreText,
  subHeading,
  mediaSize,
  videoLink,
}) => {
  const backgroundClass = useHeroBackground();
  const theme = useTheme();
  return (
    <div className={backgroundClass}>
      <BlockContainer
        className={classNames(styles.infoPageHeroBlock, {
          [styles.withMedia]: videoLink || image,
          [styles.largeMedia]: mediaSize === "large",
          [styles.dark]: theme === "dark",
        })}
        verticalPadding
      >
        <div className={styles.infoPageHeroBlockText}>
          {subHeading && <p>{subHeading}</p>}
          {heading && <h1>{heading}</h1>}
          {publishDate && (
            <span>
              <IconMS className={styles.icon} name="stylus" size="20px" />
              <p>{publishDate}</p>
            </span>
          )}
        </div>
        {(videoLink || image) && (
          <div className={styles.infoPageHeroBlockMedia}>
            <MultiMediaBlock
              video={videoLink}
              image={image}
              description={mediaText}
              byline={byline}
              expandButtonText={showMoreText}
              closeButtonText={showLessText}
              isSmallMedia={mediaSize === "small"}
              onDarkBackground={theme === "dark"}
              noBorder={true}
            />
          </div>
        )}
      </BlockContainer>
    </div>
  );
};

export default InfoPageHeroBlock;
